import { Show, createSignal } from "solid-js";
import { useUserContext } from "../UserContext";
import ExternalNameForm from "../ExternalNameForm";
import { Loader } from "../Components";
import { useNavigate } from "@solidjs/router";

export default function Home() {
  const [userStore, _setUserStore, userActions] = useUserContext() as any;
  const navigate = useNavigate();
  const [joinCode, setJoinCode] = createSignal("");

  const joinSubmit = (e: Event) => {
    e.preventDefault();
    const value = joinCode().trim().toUpperCase();
    if (!value) return;
    navigate(`/q/${value}`);
  };
  return (
    <div>
      <Show when={!userStore.isAuthenticated}>
        <Show when={!userStore.isAuthenticating} fallback={<Loader />}>
          <h1>Welcome</h1>
          <Show when={userStore.authStage === 'choose-method'}>
            <p>Choose how you want to sign in:</p>
            <div class="d-flex gap-2 mt-3">
              <button type="button" class="btn btn-primary"
                onClick={() => userActions.chooseCAS()}>
                Sign in with CAS
              </button>
              <button type="button" class="btn btn-secondary"
                onClick={() => userActions.chooseExternal()}>
                Continue as Student (no CAS)
              </button>
            </div>
          </Show>
          <Show when={userStore.authStage === 'enter-external-name'}>
            <ExternalNameForm />
          </Show>
          <Show when={userStore.authStage === 'authenticating'}>
            <Loader />
          </Show>
        </Show>
      </Show>
      <Show when={userStore.isAuthenticated}>
        <h1>Welcome to the Live Quiz Platform!</h1>
        <Show when={userStore.userType === 'external-student' || userStore.role !== 'admin'}>
          <div class="card mt-3" style={{ "max-width": "520px" }}>
            <div class="card-body">
              <h5 class="card-title">Join a Quiz</h5>
              <form class="row g-2" onSubmit={joinSubmit}>
                <div class="col-8">
                  <input
                    type="text"
                    class="form-control"
                    value={joinCode()}
                    onInput={(e) => setJoinCode(e.currentTarget.value.toUpperCase())}
                    placeholder="Enter quiz code (e.g. ABC123)"
                    pattern="[A-Z0-9]{4,10}"
                    required
                  />
                </div>
                <div class="col-4 d-grid">
                  <button type="submit" class="btn btn-primary">Join</button>
                </div>
              </form>
              <div class="form-text mt-1">Your teacher will give you the quiz code.</div>
            </div>
          </div>
        </Show>
      </Show>
    </div>
  );
}
